export const moneyToNumber = (value) => {
  let result = Number(value);
  if (isNaN(result) && value.includes(",")) {
    return Number(value.replace(",", "."));
  }
  return result;
};

export const numberToMoney = (value, currency = "UAH") =>
  new Intl.NumberFormat("uk-ua", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
  }).format(value);
